// BP-level legacy PHP action pages, opened in an overlay iframe with the BP number
// pre-filled. All but Payment Reversal accept the BP via a GET `bn` (or
// `business_partner_id`) query param; Payment Reversal only reads `invoice_payment_id`
// from $_POST, so it's submitted via a hidden form targeting the overlay iframe instead.
// Shared across BusinessPartnerReport, BilledBusinessPartnerReport, and
// UnbilledBusinessPartnerReport -- all three offer the same per-row BP actions.
export const BP_ACTION_ITEMS = [
  { key: 'ledger', label: 'BP Individual Ledger', path: (bn) => `/reports/passbook.php?business_partner_id=${bn}` },
  { key: 'change-status', label: 'BP Change Status', path: (bn) => `/action/change_status.php?bn=${bn}` },
  { key: 'change-scheme', label: 'BP Change Scheme', path: (bn) => `/action/change_scheme.php?bn=${bn}` },
  { key: 'change-outstanding', label: 'BP Change Outstanding', path: (bn) => `/action/change_outstand.php?bn=${bn}` },
  { key: 'change-meter', label: 'BP Change Meter', path: (bn) => `/action/change_meter.php?bn=${bn}` },
  { key: 'payment-reversal', label: 'Payment Reversal', post: true, action: '/action/payment_reversal.php', field: 'invoice_payment_id' },
  { key: 're-invoice', label: 'Re-Invoice', path: (bn) => `/tools/invoice_regen.php?bn=${bn}` },
  { key: 'latest-invoice', label: 'Show Latest Invoice', path: (bn) => `/v/details.php?bn=${bn}&Referer=1` },
];

export const bpActionListModalStyle = {
  overlay: { zIndex: 2200, backgroundColor: 'rgba(0,0,0,0.55)' },
  content: { maxWidth: '420px', margin: 'auto', height: 'fit-content', inset: '40px' },
};

export const bpActionOverlayModalStyle = {
  overlay: { zIndex: 2200, backgroundColor: 'rgba(0,0,0,0.55)' },
  content: { inset: '30px', display: 'flex', flexDirection: 'column', padding: '12px' },
};
